"use client"

import { CartesianGrid, Line, LineChart, XAxis } from "recharts"

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./components/ui/card"
import { type ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "./components/ui/chart"

const data = [
  {
    average: 400,
    today: 240,
    day: "월요일",
  },
  {
    average: 300,
    today: 139,
    day: "화요일",
  },
  {
    average: 200,
    today: 980,
    day: "수요일",
  },
  {
    average: 278,
    today: 390,
    day: "목요일",
  },
  {
    average: 189,
    today: 480,
    day: "금요일",
  },
  {
    average: 239,
    today: 380,
    day: "토요일",
  },
  {
    average: 349,
    today: 430,
    day: "일요일",
  },
]

const chartConfig = {
  today: {
    label: "오늘",
    color: "var(--primary)",
  },
  average: {
    label: "평균",
    color: "var(--primary)",
  },
} satisfies ChartConfig

export function CardsExerciseMinutes() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>운동 시간</CardTitle>
        <CardDescription>평소보다 운동 시간이 앞서 있습니다.</CardDescription>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig} className="w-full md:h-[200px]">
          <LineChart
            accessibilityLayer
            data={data}
            margin={{
              top: 5,
              right: 10,
              left: 16,
              bottom: 0,
            }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              dataKey="day"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              tickFormatter={(value) => value.slice(0, 1)}
            />
            <Line
              type="monotone"
              dataKey="today"
              strokeWidth={2}
              stroke="var(--color-today)"
              dot={{
                fill: "var(--color-today)",
              }}
              activeDot={{
                r: 5,
              }}
            />
            <Line
              type="monotone"
              strokeWidth={2}
              dataKey="average"
              stroke="var(--color-average)"
              strokeOpacity={0.5}
              dot={{
                fill: "var(--color-average)",
                opacity: 0.5,
              }}
              activeDot={{
                r: 5,
              }}
            />
            <ChartTooltip content={<ChartTooltipContent />} />
          </LineChart>
        </ChartContainer>
      </CardContent>
    </Card>
  )
}
